import {
  LEAVE_ROLE,
  PAGE_IN_MODULE,
  TOP_ROLE_ID,
  DEBUGGER_CORP,
  DEBUGGERID
} from '@/utils/constUtils'
import {
  uniqueArray,
  setItem,
  getItem,
  setLocalItem,
  getLocalItem,
  isWxPlatform
} from '@/utils/comUtils'
import API from '@/api'
// state  getters 已在 mixin/index 处理,可以直接使用
// 拆分文件 未做模块嵌套

const ROLE_ID_LIST = 'roleIdList'
const MODULE_LIST = 'moduleList'
export default {
  namespaced: true,
  state: {
    topRole: getItem(TOP_ROLE_ID) || 0,
    moduleList: getItem(MODULE_LIST) || [], // 老师可查看的权限模块
    roleIdList: getItem(ROLE_ID_LIST) || [] // 所包含的所有角色
  },
  getters: {
    // 是否包含某角色
    token(state) {
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      return _token
    },
    // 获取当前选择校区信息
    currentCapmus(state, getters) {
      let _currentCapmus = state.currentCapmus
      if (!_currentCapmus) {
        let _token = getters.token || {}
        _currentCapmus = getLocalItem(`CURRENT_CAPMUS_${_token.orgId}`) || {}
        state.currentCapmus = _currentCapmus
      }

      return _currentCapmus
    },
    // 当前校区
    capmusList(state, getters) {
      let { currentCapmus } = getters
      return [currentCapmus]
    },
    // 获取当前角色
    currentRole(state, getters) {
      let _currentRole = state.currentRole
      if (!_currentRole) {
        let _token = getters.token || {}
        _currentRole = +getLocalItem(`CURRENT_ROLE_${_token.orgId}`)
      }
      state.currentRole = _currentRole
      return _currentRole
    },
    // 是否有权限使用微应用
    isCanAccess(state, getters) {
      // 普通老师及成员暂无权限
      return (
        getters.isGuardian ||
        getters.isTeacher ||
        getters.isHeadmaster ||
        getters.isAdmin ||
        getters.isCustomRole ||
        getters.isDormAdmin ||
        getters.isStudent
      )
    },
    // 是否可切换角色
    isCanChangeRole(state, getters) {
      // 角色多个 或者单个角色管理多个校区 时才可以切换角色
      // 请注意安全员角色可以切校区
      let { isCombineTeacher, isGuardian, teacherCampusList } = getters
      let _roleNum = 0

      if (isCombineTeacher) {
        _roleNum += teacherCampusList.length
      }
      if (isGuardian) {
        _roleNum += 1
      }
      return _roleNum > 1 && !isWxPlatform()
    },

    // 是否包含某角色属性
    // 管理员
    isAdmin(state, getters) {
      let { token } = getters
      return !!(token && token.isAdmin)
    },
    // 宿舍管理员
    isDormAdmin(state, getters) {
      let { token } = getters
      return !!(token && token.isDormAdmin)
    },
    // 自定义角色
    isCustomRole(state, getters) {
      let { token } = getters
      return !!(token && token.isCustomRole)
    },
    // 是否是老师-普通任课老师
    isTeacher(state, getters) {
      let { token } = getters
      return !!(token && token.schoolInfo && token.schoolInfo.isTeacher)
    },
    // 班主任-机构内任意校区
    isHeadmaster(state, getters) {
      let { token } = getters
      return !!(token && token.schoolInfo && token.schoolInfo.isHeadmaster)
    },

    // 角色大类属性
    // 老师-家长-学生
    isCombineTeacher(state, getters) {
      let { isAdmin, isCustomRole, isHeadmaster, isDormAdmin, isTeacher } =
        getters
      return isAdmin || isCustomRole || isHeadmaster || isDormAdmin || isTeacher
    },
    // 是否是家长
    isGuardian(state, getters) {
      let { token } = getters
      return !!(token && token.schoolInfo && token.schoolInfo.isGuardian)
    },
    // 是否是学生
    isStudent(state, getters) {
      let { token } = getters
      return !!(token && token.schoolInfo && token.schoolInfo.isStudent)
    },

    // 当前角色是否为此角色
    // 老师大类 区分于普通老师
    curIsTeacher(state, getters) {
      return getters.currentRole === LEAVE_ROLE.classTeacher
    },
    // 家长
    curIsGuardian(state, getters) {
      return getters.currentRole === LEAVE_ROLE.guardian
    },
    // 学生
    curIstudent(state, getters) {
      return getters.currentRole === LEAVE_ROLE.student
    },
    // 管理员
    curIsAdmin(state) {
      return state.roleIdList.includes(LEAVE_ROLE.admin)
    },
    // 自定义角色
    curIsCustomRole(state) {
      return state.roleIdList.includes(LEAVE_ROLE.customRole)
    },
    // 自定义角色-兼容老数据
    isCurCustomRole(state, getters) {
      return getters.curIsCustomRole
    },
    // 班主任-当前校区
    curIsCampusHeadmaster(state) {
      return state.roleIdList.includes(LEAVE_ROLE.headmaster)
    },
    // 班主任-当前校区-兼容老数据
    isCampusHeadmaster(state, getters) {
      return getters.curIsCampusHeadmaster
    },
    // 宿舍管理员
    curIsDormAdmin(state) {
      return state.roleIdList.includes(LEAVE_ROLE.dormAdmin)
    },
    // 任课老师
    curIsClassTeacher(state) {
      return state.roleIdList.includes(LEAVE_ROLE.teacher)
    },
    // 选修课老师
    curIsElectiveClassTeacher(state) {
      return state.roleIdList.includes(LEAVE_ROLE.elecTeacher)
    },
    // 课堂行为老师
    curIsBehavior(state) {
      return state.roleIdList.includes(LEAVE_ROLE.behaviorTeacher)
    },
    // 任课老师
    isClassTeacher(state, getters) {
      return getters.curIsClassTeacher
    },
    // 德育考评-是否能考评
    isAblleMoral(state, getters) {
      let {
        curIsAdmin,
        curIsCampusHeadmaster,
        curIsMeTeacher,
        curIsClassTeacher
      } = getters
      return (
        curIsAdmin ||
        curIsCampusHeadmaster ||
        curIsMeTeacher ||
        curIsClassTeacher
      )
    },
    // 德育考评老师
    curIsMeTeacher(state) {
      return state.roleIdList.includes(LEAVE_ROLE.meTeacher)
    },
    // 德育考评老师
    isMeTeacher(state, getters) {
      return getters.curIsMeTeacher
    },
    // 德育-考评班级 对应的角色合并
    curIsMoralEvaTeacher(state, getters) {
      return getters.curIsClassTeacher || getters.curIsMeTeacher
    },
    // 班级考评老师
    curIsCeTeacher(state) {
      return state.roleIdList.includes(LEAVE_ROLE.ceTeacher)
    },
    // 班级考评老师
    isCETeacher(state, getters, rootState, rootGetters) {
      return getters.curIsCeTeacher
    },
    // 滞留生老师
    curIseTeacher(state) {
      return state.roleIdList.includes(LEAVE_ROLE.seTeacher)
    },
    // 滞留生老师
    isScheduleTeacher(state, getters, rootState, rootGetters) {
      return getters.curIseTeacher
    },
    // 课堂行为巡查老师
    isBehaviorTeacher(state, getters, rootState, rootGetters) {
      let { token } = getters
      return !!(((token || {}).schoolInfo || {}).teacherRole || {})
        .isCbaPatrolTeacher
    },
    // 班级或者校区相关
    // 班主任管理班级列表
    classList(state, getters) {
      let { token, isHeadmaster, currentCapmus } = getters
      let _classList = []
      let _currentCapmus = currentCapmus || {}
      if (isHeadmaster) {
        let _headmasterClass = token.schoolInfo.headmasterClass || []
        _headmasterClass.forEach(item => {
          if (item.tpId === _currentCapmus.tpId) {
            item.schoolClassDtoList.forEach(itm => {
              _classList.push({
                name: itm.name,
                deptId: itm.deptId,
                tpId: itm.tpId
              })
            })
          }
        })
      }
      return _classList
    },
    // 家长学生列表
    studentList(state, getters) {
      if (state.studentList && state.studentList.length) {
        return state.studentList
      }
      let _studentList = []
      let { token, isGuardian } = getters

      if (isGuardian) {
        let _classList = token.schoolInfo.guardianClass
        _classList.forEach(item => {
          if (item.studentList && item.studentList.length > 0) {
            let _students = item.studentList.map(student => {
              return {
                classic: item.classic,
                name: student.name,
                memberId: student.memberId,
                tpId: student.tpId,
                classId: item.deptId,
                dingClassesId: item.tpId,
                // tpParentId: item.tpId,
                className: item.name,
                gender: student.gender,
                accommodationTagName: student.accommodationTagName,
                tagOptionList: student.tagOptionList || [],
                dormName: student.dormName,
                campusId: item.campusId
              }
            })
            _studentList = _studentList.concat(_students)
          }
        })
      }
      state.studentList = _studentList
      return _studentList
    },
    // 班级列表（仅限普通任课老师） 普通任课老师管理的班级列表
    teacherClassList(state, getters) {
      let _teacherClassList = []
      let { token, currentCapmus } = getters
      let _currentCapmus = currentCapmus || {}
      let _teacherRole =
        token && token.schoolInfo && token.schoolInfo.teacherRole
      if (_teacherRole && _teacherRole.isTeacher) {
        let _teacherClass = _teacherRole.teacherClass || []
        _teacherClass.forEach(item => {
          if (item.tpId === _currentCapmus.tpId) {
            item.schoolClassDtoList.forEach(item => {
              _teacherClassList.push({
                name: item.name,
                deptId: item.deptId,
                tpId: item.tpId
              })
            })
          }
        })
      }
      return _teacherClassList
    },
    // 所有校区列表
    campusList(state, getters) {
      let { token } = getters
      return (token || {}).allCampus || []
    },
    // 自定义角色校区列表
    customRoleCampusList(state, getters) {
      let { token } = getters
      return (token || {}).customRoleCampus || []
    },
    // 班主任校区列表
    classCampus(state, getters) {
      let _classCampus = []
      let { token, isHeadmaster } = getters

      if (isHeadmaster) {
        let _headmasterClass = token.schoolInfo.headmasterClass
        _classCampus = _headmasterClass.map(item => {
          return {
            name: item.name,
            classic: item.classic,
            tpId: item.tpId
          }
        })
      }
      state.classCampus = _classCampus
      return _classCampus
    },
    // 宿舍管理员管理的校区列表
    dormList(state, getters) {
      let { token } = getters
      return (token || {}).dormList || []
    },
    // 任课老师校区
    teacherCampus(state, getters) {
      let { token, isTeacher } = getters
      let _teacherClass = []
      if (isTeacher) {
        const { teacherClass = [], electiveClassTeacherCampus = [] } =
          token.schoolInfo.teacherRole
        _teacherClass = [...teacherClass, ...electiveClassTeacherCampus]
      }
      // 数组去重
      return uniqueArray(_teacherClass, 'tpId')
    },
    // 任课老师校区
    classTeacherCampus(state, getters) {
      return getters.teacherCampus
    },
    // 德育老师校区
    meTeacherCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const { isMoralEduTeacher, moralEduTeacherCampus = [] } = teacherRole
        return isMoralEduTeacher ? moralEduTeacherCampus : []
      }
      return []
    },
    // 班级考评老师校区
    ceTeacherCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const { isClassEvaluationTeacher, classEvaluationTeacherCampus = [] } =
          teacherRole
        return isClassEvaluationTeacher ? classEvaluationTeacherCampus : []
      }
      return []
    },
    // 班级评比审批老师
    ceAuditMemberCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const {
          isClassEvaluationAuditMember,
          classEvaluationAuditMemberCampus = []
        } = teacherRole
        return isClassEvaluationAuditMember
          ? classEvaluationAuditMemberCampus
          : []
      }
      return []
    },
    // 滞留生值班老师所在校区
    scheduleTeacherCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const { isScheduleTeacher, scheduleTeacherCampus = [] } = teacherRole
        return isScheduleTeacher ? scheduleTeacherCampus : []
      }
      return []
    },
    // 巡查老师所在校区
    behaviorTeacherCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const { isCbaPatrolTeacher, cbaPatrolTeacherCampus = [] } = teacherRole
        return isCbaPatrolTeacher ? cbaPatrolTeacherCampus : []
      }
      return []
    },
    // 老师分类下的校区列表
    teacherCampusList(state, getters) {
      let {
        campusList,
        customRoleCampusList,
        classCampus,
        dormList,
        teacherCampus,
        meTeacherCampus,
        ceTeacherCampus,
        ceAuditMemberCampus,
        scheduleTeacherCampus,
        securityManagerCampus,
        areaPoliceTeacherCampus,
        behaviorTeacherCampus
      } = getters

      let _allList = [
        ...campusList,
        ...customRoleCampusList,
        ...classCampus,
        ...dormList,
        ...teacherCampus,
        ...meTeacherCampus,
        ...ceTeacherCampus,
        ...ceAuditMemberCampus,
        ...scheduleTeacherCampus,
        ...securityManagerCampus,
        ...areaPoliceTeacherCampus,
        ...behaviorTeacherCampus
      ]
      // 去重
      let _campusList = _allList.length && uniqueArray(_allList, 'tpId')
      return _campusList || []
    },
    securityManagerCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const {
          isAreaPoliceManagerTeacher,
          areaPoliceManagerTeacherCampus = []
        } = teacherRole
        return isAreaPoliceManagerTeacher ? areaPoliceManagerTeacherCampus : []
      }
      return []
    },
    curIsSecurityManager(state) {
      return state.roleIdList.includes(LEAVE_ROLE.securityManager)
    },
    isSecurityManager(state) {
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      return (
        _token &&
        _token.schoolInfo &&
        _token.schoolInfo.teacherRole.isAreaPoliceManagerTeacher
      )
    },
    areaPoliceTeacherCampus(state, getters) {
      let { token } = getters
      if (token && token.schoolInfo) {
        const { teacherRole = {} } = token.schoolInfo
        const { isAreaPoliceTeacher, areaPoliceTeacherCampus = [] } =
          teacherRole
        return isAreaPoliceTeacher ? areaPoliceTeacherCampus : []
      }
      return []
    },
    curIsSecurityPolicer(state) {
      return state.roleIdList.includes(LEAVE_ROLE.securityPolicer)
    },
    isSecurityPolicer(state) {
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      return (
        _token &&
        _token.schoolInfo &&
        _token.schoolInfo.teacherRole.isAreaPoliceTeacher
      )
    }
  },
  mutations: {
    initRoleIdList(state, idList) {
      state.roleIdList = getRoleHighToLow(idList)
      setItem(ROLE_ID_LIST, state.roleIdList)
    },
    initTopRole(state, getters) {
      state.topRole = getTopRole(getters)
      setItem(TOP_ROLE_ID, state.topRole)
    },
    initModuleList(state, moduleList) {
      state.moduleList = moduleList
      setItem(MODULE_LIST, state.moduleList)
    },
    // 切换当前角色
    changeCurrentRole(state, role) {
      state.token = state.token || getItem('TOKEN')
      state.currentRole = role
      setLocalItem(`CURRENT_ROLE_${state.token.orgId}`, role)
    }
  },
  actions: {
    async getRoleIdList({ commit, getters, state }) {
      try {
        let _accessRoleList = [
          LEAVE_ROLE.admin,
          LEAVE_ROLE.customRole,
          LEAVE_ROLE.dormAdmin,
          LEAVE_ROLE.headmaster,
          LEAVE_ROLE.teacher,
          LEAVE_ROLE.classTeacher,
          LEAVE_ROLE.securityPolicer,
          LEAVE_ROLE.securityManager,
          LEAVE_ROLE.behaviorTeacher
        ]
        if (
          _accessRoleList.includes(getters.currentRole) ||
          getters.curIsTeacher
        ) {
          commit('initTopRole', getters)
          let res = await API.getTeacherRole({
            operUserRoleTypes: getters.currentRole,
            campusId: getters.currentCapmus.tpId
          })
          let { roleList = [], moduleList = [] } = res || {}
          // 数据大屏灰度的时候 班主任可见
          if (
            state.functinList.some(
              item => item.functionName === 'schoolHeadmasterCastScreen'
            )
          ) {
            if (roleList.some(role => role === LEAVE_ROLE.headmaster)) {
              if (
                state.skuInfo.moduleIdList.some(
                  module => +module === PAGE_IN_MODULE.screen
                )
              ) {
                moduleList.push(PAGE_IN_MODULE.screen)
              }
            }
          }
          if (
            DEBUGGER_CORP.includes(getItem('corpId')) ||
            getItem('debugId') === DEBUGGERID
          ) {
            moduleList.unshift(PAGE_IN_MODULE.auth)
          }
          commit('initRoleIdList', roleList)
          commit('initModuleList', moduleList)
        } else {
          // 防止老师切换到家长时 数据缓存
          commit('initRoleIdList', [])
          commit('initModuleList', [])
        }
      } catch (error) {
        console.log(error)
      }
    },
    initCurrentRole({ commit, getters }) {
      // 优先级 老师-家长-学生
      let { isCombineTeacher, isGuardian, isStudent } = getters
      /* eslint-disable */
      let _currentRole = isCombineTeacher
        ? LEAVE_ROLE.classTeacher
        : isGuardian
        ? LEAVE_ROLE.guardian
        : isStudent
        ? LEAVE_ROLE.student
        : ''
      commit('changeCurrentRole', _currentRole)
    },
    initRedircetCurrentRole({ commit, getters }) {
      commit('initTopRole', getters)

      let _currentRole = getTopRole(getters)

      let {
        isAdmin,
        isCustomRole,
        isDormAdmin,
        isHeadmaster,
        isTeacher,
        isBehaviorTeacher
      } = getters
      // 外链初始化角色列表
      let _roleIdList = []

      isAdmin && _roleIdList.push(LEAVE_ROLE.admin)
      isCustomRole && _roleIdList.push(LEAVE_ROLE.customRole)
      isDormAdmin && _roleIdList.push(LEAVE_ROLE.dormAdmin)
      isHeadmaster && _roleIdList.push(LEAVE_ROLE.headmaster)
      isTeacher && _roleIdList.push(LEAVE_ROLE.teacher)
      isBehaviorTeacher && _roleIdList.push(LEAVE_ROLE.behaviorTeacher)
      // 外链特殊的业务老师
      commit('changeCurrentRole', _currentRole)
      commit('initRoleIdList', _roleIdList)
    }
  }
}

function getTopRole(getters) {
  // 优先级 管理员-班主任-自定义角色-老师-业务类老师（宿舍管理员-值日老师-考评老师等）-家长-学生
  let {
    isAdmin,
    isCustomRole,
    isDormAdmin,
    isHeadmaster,
    isGuardian,
    isTeacher,
    isStudent
  } = getters

  /* eslint-disable */
  return isAdmin
    ? LEAVE_ROLE.admin
    : isHeadmaster
    ? LEAVE_ROLE.headmaster
    : isCustomRole
    ? LEAVE_ROLE.customRole
    : isTeacher
    ? LEAVE_ROLE.teacher
    : isDormAdmin
    ? LEAVE_ROLE.dormAdmin
    : isGuardian
    ? LEAVE_ROLE.guardian
    : isStudent
    ? LEAVE_ROLE.student
    : ''
}
/**
 * @description 按照 getTopRole 的角色优先级，重新排列角色列表
 * @param {Array} roleList 角色列表
 * @return {Array} 从低到高的角色列表
 */
function getRoleHighToLow(roleList = []) {
  let roleLen = roleList.length
  if (roleLen <= 1) return roleList

  // 目前只需处理如下几种
  let lowToHighList = [
    LEAVE_ROLE.behaviorTeacher,
    LEAVE_ROLE.teacher,
    LEAVE_ROLE.customRole,
    LEAVE_ROLE.headmaster,
    LEAVE_ROLE.admin
  ]
  lowToHighList.forEach(role => {
    let index = roleList.findIndex(item => item === role)
    if (index >= 0) {
      roleList.splice(index, 1)
      roleList.unshift(role)
    }
  })

  return roleList
}
